import { render, staticRenderFns } from "./Create-update.vue?vue&type=template&id=62604582&scoped=true"
import script from "./Create-update.vue?vue&type=script&lang=js"
export * from "./Create-update.vue?vue&type=script&lang=js"
import style0 from "./Create-update.vue?vue&type=style&index=0&id=62604582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62604582",
  null
  
)

export default component.exports